const sessionCaptureKeys = new Set<string>();

export function sessionCaptureOnce(key: string): boolean {
  if (sessionCaptureKeys.has(key)) return false;
  sessionCaptureKeys.add(key);
  return true;
}
